"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appStateSelectAppId_1 = __importDefault(require("../../shared/appStateSelectAppId"));
const appStateSelectProjectId_1 = __importDefault(require("../../shared/appStateSelectProjectId"));
const buildCallableSendEmailVerification = (args) => async ({ functionId, callbacks, executeProcesses, processor, store, }) => {
    const { currentUser } = processor.root.firebase.auth();
    if (!currentUser) {
        executeProcesses(functionId, callbacks.userIsNotLoggedIn);
        return;
    }
    const state = store.getState();
    const projectId = (0, appStateSelectProjectId_1.default)(state);
    const appId = (0, appStateSelectAppId_1.default)(state);
    if (processor.root.isInDevelopment) {
        const emailIsVerified = await args
            .checkInLocalIfUserEmailVerified(currentUser.uid, projectId);
        if (emailIsVerified) {
            executeProcesses(functionId, callbacks.userIsAlreadyValidated);
            return;
        }
        const userEmail = currentUser.email;
        if (!userEmail) {
            throw new Error('no userEmail found');
        }
        const emailIsSent = await args.sendEmailToValidateEmail(currentUser.uid, userEmail, projectId, appId);
        if (emailIsSent) {
            executeProcesses(functionId, callbacks.successProcess);
            return;
        }
        executeProcesses(functionId, callbacks.errorProcess);
        return;
    }
    const emailIsVerified = await args.checkInHostIfAuthUserEmailIsValidated(appId);
    if (emailIsVerified) {
        executeProcesses(functionId, callbacks.userIsAlreadyValidated);
        return;
    }
    if (currentUser.sendEmailVerification) {
        currentUser.sendEmailVerification().then(() => {
            executeProcesses(functionId, callbacks.successProcess);
        }).catch((error) => {
            executeProcesses(functionId, callbacks.errorProcess, error.message);
        });
    }
};
exports.default = buildCallableSendEmailVerification;
